import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cs from 'classnames';
import * as COLORS from 'Constants/colors';
import Text from 'Components/Text';
import Select from 'Components/Select';
import Input from 'Components/Input';
import TextArea from 'Components/TextArea';
import Button from 'Components/Button';
import SelectDate from 'Components/SelectDate';
import SelectPeople from 'Components/SelectPeople';
import { formKeys } from './index';

const ProvisionalTwoColumns = ({
  className,
  date,
  errors = {},
  onChange,
  assistancePrefers,
  listPhoneCodes,
  prefers,
  name,
  email,
  phoneCode,
  phone,
  query,
  onSubmit,
  touched = {},
  title,
  datePrices
}) => (
  <div className={cs(className)}>
    <Text context="important" weight="semi-bold" size="xlarge">
      {title || 'Armemos tu viaje juntos'}
    </Text>
    <div className="content-body">
      <div className="form-row">
        <div className="form-label">
          <Text weight="semi-bold">Fecha de viaje:</Text>
          <SelectDate
            className="input"
            onChange={onChange(formKeys.date)}
            selectedValue={date}
            datePrices={datePrices}
            error={{
              message: !touched.date && 'Elegí tu fecha ideal',
              color: 'info'
            }}
          />
        </div>
        <div className="form-label">
          <Text weight="semi-bold">Pasajeros:</Text>
          <SelectPeople
            className="input"
            onChange={onChange(formKeys.people)}
            error={{
              message: errors.people
                ? 'La edad de los menores es requerida'
                : undefined,
              color: 'warning'
            }}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-label">
          <Text weight="semi-bold">Via de contacto:</Text>
          <Select
            className="input"
            placeholder="¿Por qué medio te contactamos?"
            onSelect={onChange(formKeys.prefers)}
            selectedValue={prefers && prefers.id}
            items={assistancePrefers}
            message={errors.prefers}
            context={errors.prefers && 'warning'}
          />
        </div>
        <div className="form-label">
          <Text weight="semi-bold">Nombre:</Text>
          <Input
            placeholder="Ingresá tu nombre"
            className="input"
            onChange={onChange(formKeys.name)}
            value={name}
            message={errors.name}
            context={errors.name && 'warning'}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-label">
          <Text weight="semi-bold">Correo electrónico:</Text>
          <Input
            placeholder="Ej: hola@mevuelo.com"
            className="input"
            onChange={onChange(formKeys.email)}
            value={email}
            message={errors.email}
            context={errors.email && 'warning'}
          />
        </div>
        <div className="form-label">
          <Text weight="semi-bold">Teléfono:</Text>
          <div className="form-row">
            <div className="column">
              <Select
                className="input"
                items={listPhoneCodes}
                onSelect={onChange(formKeys.phoneCode)}
                selectedValue={phoneCode && phoneCode.id}
                message={errors.phoneCode}
                context={errors.phoneCode && 'warning'}
              />
            </div>
            <div className="column">
              <Input
                placeholder="Número de teléfono"
                className="input"
                onChange={onChange(formKeys.phone)}
                value={phone}
                message={errors.phone}
                context={errors.phone && 'warning'}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="form-row" />
      <TextArea
        className="input"
        placeholder="¿Algún comentario?"
        value={query}
        onChange={onChange(formKeys.query)}
        message={errors.query}
        context={errors.query && 'warning'}
      />
      <Button className="input" onClick={onSubmit}>
        Envianos tu consulta
      </Button>
    </div>
  </div>
);

ProvisionalTwoColumns.propTypes = {
  className: PropTypes.string,
  date: PropTypes.string,
  people: PropTypes.shape({
    adultsCount: PropTypes.number.isRequired,
    childrenQty: PropTypes.number.isRequired
  }),
  prefers: PropTypes.shape({
    id: PropTypes.number.isRequired
  }),
  query: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  phoneCode: PropTypes.shape({
    id: PropTypes.string.isRequired
  }),
  onChange: PropTypes.func.isRequired,
  assistancePrefers: PropTypes.any,
  listPhoneCodes: PropTypes.any,
  name: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object,
  touched: PropTypes.object,
  title: PropTypes.node,
  datePrices: PropTypes.object
};

const StyledProvisionalTwoColumns = styled(ProvisionalTwoColumns)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 14px;
  box-shadow: ${({ theme }) => theme.shadows.three};
  padding: 5px;

  .content-header {
    display: flex;
    align-items: center;
  }

  .column {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: ${({ theme }) => theme.spacing.one};
    width: 100%;
  }

  .form-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    margin-left: 0;

    .form-label {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin: ${({ theme }) => theme.spacing.one};
    }
  }

  .input {
    margin-bottom: ${({ theme }) => theme.spacing.four};
    width: 100%;
  }

  .content-body {
    display: flex;
    align-content: center;
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing.four};
    width: 100%;
  }

  .separator {
    width: 100%;
    border-top: 1px solid ${COLORS.lightGrey};
  }
`;
export default StyledProvisionalTwoColumns;
